import React from 'react'
import { Input } from 'antd'
import { FiInfo, FiCheckCircle } from 'react-icons/fi'
import InfoCard from './InfoCard'
import styles from './FeedbackModal.module.css'

const FeedbackQuestionStep = ({
  question,
  feedback,
  validationError,
  onScoreChange,
  onCommentsChange
}) => {
  const scoreButtons = Array.from({ length: 10 }, (_, i) => i + 1)

  const getScoreQuality = (score) => {
    if (!score) return {}
    if (score <= 4)
      return {
        text:
          score <= 2 ? '— Very poor (unusable)' : '— Poor (major edits needed)',
        className: styles.low
      }
    if (score <= 6)
      return { text: '— Acceptable (minor edits)', className: styles.medium }
    if (score <= 8)
      return { text: '— Good (small tweaks)', className: styles.high }
    return { text: '— Excellent (publishable)', className: styles.high }
  }

  const scoreQuality = getScoreQuality(feedback.score)

  const infoCards = [
    {
      icon: FiInfo,
      label: 'Definition',
      content: question.definition,
      className: styles.definition
    },
    {
      icon: FiCheckCircle,
      label: 'Reviewer hint',
      content: question.hint,
      className: styles.definition
    }
  ]

  return (
    <div className={styles.questionContainer}>
      <h4 className={styles.questionTitle}>{question.title}</h4>

      <div className={styles.infoSection}>
        {infoCards.map((card, index) => (
          <InfoCard
            key={index}
            icon={card.icon}
            label={card.label}
            content={card.content}
            className={card.className}
          />
        ))}
      </div>

      <div className={styles.scoreSection}>
        <label className={styles.scoreLabel}>Score (1-10)</label>

        <div className={styles.scoreButtons}>
          {scoreButtons.map((score) => (
            <button
              key={score}
              type="button"
              className={`${styles.scoreButton} ${
                feedback.score === score.toString() ? styles.selected : ''
              }`}
              onClick={() => onScoreChange(score.toString())}
            >
              {score}
            </button>
          ))}
        </div>

        {validationError && (
          <div className={styles.error}>{validationError}</div>
        )}

        {feedback.score && (
          <div className={styles.scoreFeedback}>
            <span className={styles.scoreValue}>{feedback.score}/10</span>
            <span
              className={`${styles.scoreQuality} ${scoreQuality.className}`}
            >
              {scoreQuality.text}
            </span>
          </div>
        )}
      </div>

      <div>
        <label className={styles.label}>Comments (optional)</label>
        <Input.TextArea
          value={feedback.comments}
          onChange={(e) => onCommentsChange(e.target.value)}
          placeholder="Share your thoughts on this aspect"
          rows={4}
        />
      </div>
    </div>
  )
}

export default FeedbackQuestionStep
